import { Grid, styled } from '@mui/material'

export const DatePickerWrapper = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    maxHeight: 300,
  },
  justifyContent: 'center',
}))
